module.exports = __webpack_public_path__ + "img/ai-input-api.7d399774.svg";